module.exports = __webpack_public_path__ + "static/media/oberflex-cheneteintechenedesmarais-2560x1440.e8eaa9d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-cheneteintechenedesmarais-2560x1440.jpg
// module id = 1001
// module chunks = 37